import React, { Component } from 'react';
import { connect } from "react-redux";
import Highlighter from 'react-highlight-words';
import SearchSelectList from '../SearchSelectList';
import SearchSelectListItem from '../SearchSelectListItem';
import {
    getProductGroups,
    addProductGroupFavorite,
    removeProductGroupFavorite
} from '../../../actions/userActions';
import _ from 'underscore';

// SASS Imports
require('./ProductGroupSearchSelectList.scss');

function mapStateToProps (store) {
    return { favorites: store.favorites.productGroups };
};

function mapDispatchToProps (dispatch, ownProps) {
    return {
        getProductGroups: (filterQuery, productFamilyQuery, size, from) =>
            dispatch(getProductGroups({
                filterQuery,
                productFamilyQuery,
                size,
                from
            })),
        addFavorite: (productGroup) =>
            dispatch(addProductGroupFavorite(productGroup)),
        removeFavorite: (productGroup) =>
            dispatch(removeProductGroupFavorite(productGroup))
    };
}

class ProductGroupSearchSelectList extends Component {
    constructor(props) {
        super(props);

        // see the note for staticList in AccountSearchSelectList
        this.state = {
            staticList: (props.favorites) ? props.favorites.slice() : []
        };

        this.renderItem = this.renderItem.bind(this);
        this.onFetch = this.onFetch.bind(this);
        this.onBeforeItem = this.onBeforeItem.bind(this);
        this._lastProductFamilyId = null;
    }

    onFetch(filterQuery, productFamilyQuery, size, from) {
        return this.props.getProductGroups(
            filterQuery,
            productFamilyQuery,
            size,
            from
        );
    }

    onBeforeItem(item, index, props) {
        let previous = this._lastProductFamilyId;
        this._lastProductFamilyId = item.productFamilyId;
        let searchValue = this.props.searchValue ? this.props.searchValue.trim() : '';

        if((item.productFamilyId !== previous || index === 0) && !props.isShowingStatic) {
            return (
                <div key={`${searchValue}-${index}`} className="row listLabel">
                    <div className="col-md-12">
                        <h6>{item.productFamilyDescr}</h6>
                    </div>
                </div>
            );
        }

        return null;
    }

    renderProductLines (productGroup) {
        const result = [];

        if (productGroup.productLines.length === 1) {
            if (
                productGroup.productLines[0].productLineDescr
                    === productGroup.productGroupDescr
            ) {
                return null;
            }
        }

        for (let i = 0; i < productGroup.productLines.length; ++i) {
            result.push(productGroup.productLines[i].productLineDescr);
        }

        return result.join(' | ');
    }

    renderItem (productGroup, props, searchValue) {
        const highlightTokens = searchValue.toLowerCase().split(/\s+/);

        function wrap (text) {
            if (text) {
                return (
                    <Highlighter
                        highlightClassName="searchHighlight"
                        searchWords={highlightTokens}
                        textToHighlight={text}
                        autoEscape={true}
                    />
                );
            }
            return '';
        }

        return (
            <SearchSelectListItem
                item={productGroup}
                key={productGroup.productGroupId}
                selectText="Select Group"
                onSelectItem={this.props.onSelectItem}
                hasAddToFavorites={this.props.hasAddToFavorites}
                rowClassName="productGroupListItem"
                {...props}
            >
                <h5 className="productGroupName">{wrap(productGroup.productGroupDescr)}</h5>
                <p className="productLineDescr">
                    {wrap(this.renderProductLines(productGroup))}
                </p>
            </SearchSelectListItem>
        );
    }

    render() {
        return (
            <SearchSelectList
                title="Select Your Product Group"
                searchPlaceholder="Search Product Group"
                filterPlaceholder="Filter By Product Family"
                staticListResults={this.state.staticList}
                onFetch={this.onFetch}
                onBeforeItem={this.onBeforeItem}
                showFilter={false}
                onReset={() => this._lastProductFamilyId = null}
                itemProps={{
                    hasAddToFavorites: true,
                    onFavoriteItem: (productGroup) =>
                        this.props.addFavorite(productGroup),
                    onRemoveFavoriteItem: (productGroup) =>
                        this.props.removeFavorite(productGroup)
                }}
                renderItem={this.props.renderItem ? this.props.renderItem : this.renderItem}
                {...this.props}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductGroupSearchSelectList);



// WEBPACK FOOTER //
// ./app/components/SelectLists/Types/ProductGroupSearchSelectList.jsx